export const APP_URL = "http://dev.app.shomio.com/console";
export const EDITOR_URL = "http://dev.app.shomio.com/edit";